import styled from "styled-components";

export const CardContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
  }
  ${({ theme }) =>
  `
    font-family: ${theme.font.primary};
  `}
  display: flex;
  flex-direction: column;
  padding: 48px 0;
  background: #FFFFFF;
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;

  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #475467;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    img {
      margin-right: 8px;
    }
  }
`
